import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { replaceTimeStampWithDateObject } from '@modules/common/utils';
import { useMemo } from 'react';

export const useGetQuantifyStateFromAnalysisStore = () => {
  const metadata = useAnalysisStore(({ metadata }) => metadata);

  const parsedMetadata = useMemo(() => {
    let parsedJson;

    try {
      parsedJson = JSON.parse(metadata ?? '{}');
    } catch (error) {
      console.error('Error parsing JSON:', error);
      parsedJson = {};
    }

    return {
      ...parsedJson,
      query: {
        ...parsedJson.query,
        duration: replaceTimeStampWithDateObject(parsedJson.query?.duration),
        compareTo:
          parsedJson.query?.compareTo?.type === 'timerange'
            ? {
                ...parsedJson.query?.compareTo,
                duration: replaceTimeStampWithDateObject(
                  parsedJson.query?.compareTo?.duration,
                ),
              }
            : parsedJson.query?.compareTo,
      },
    };
  }, [metadata]);

  return parsedMetadata;
};
